<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link class="flex text-indigo-400 group-hover:text-indigo-600" :href="route('qrcodes')">
        <icon name="qr-code" class="w-8 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> QR Codes /
      </inertia-link>
      <span class="flex ml-1 font-medium">
        {{ form.name }}
      </span>
    </h1>
    <trashed-message v-if="qrcode.deleted_at" class="mb-6" @restore="restore">
      Este qrcode foi excluído.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-if="showOrganizations" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full" label="Organização">
            <option :value="null" />
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <!--          <div style="height: 150px">-->
          <!--            <qrcode id="qrcode_generate" :size="100" cls="qrcode" :value="qrcode.interaction" />-->
          <!--          </div>-->
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " label="Nome" />
          <textarea-input v-model="form.description" :error="form.errors.description"
                          class="pr-6 pb-8 w-full " label="Descrição"
          />
          <text-input v-model="form.code" :error="form.errors.code" class="pr-6 pb-8 w-full " label="Código" />
          URL:&nbsp;[<a :href="qrcode.url" class="no-underline hover:underline"
                        target="_blank"
          >abrir</a>]<br /><br />
          <text-input v-model="form.url" :error="form.errors.url" placeholder="Ex.: https://www.google.com"
                      class="pr-6 pb-8 w-full "
          />
          <div class="pr-6 pb-8 w-full ">
            <label>Data Inicial:</label><br /><br />
            <datepicker v-model="form.start_date" :language="ptBR" :error="form.errors.start_date"
                        :format="customFormatter" placeholder="Selecione..."
            />
          </div>
          <div class="pr-6 pb-8 w-full ">
            <label>Data Final:</label><br /><br />
            <datepicker v-model="form.end_date" :language="ptBR" :error="form.errors.end_date"
                        :format="customFormatter" placeholder="Selecione..."
            />
          </div>

          <text-input v-model="form.lat" :error="form.errors.lat" class="pr-6 pb-8 lg:w-1/2 " label="Latitude" />
          <text-input v-model="form.lng" :error="form.errors.lng" class="pr-6 pb-8 lg:w-1/2 " label="Longitude" />

          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2"
                      label="Fone"
          />

          <div class="flex w-full">
            <file-input
              v-model="form.photo"
              :error="form.errors.photo"
              class="pr-6 pb-8 w-full"
              type="file"
              accept="image/*"
              label="Imagem"
            />

            <a v-if="qrcode.photo" class="my-auto mr-3 btn-indigo" :href="qrcode.photo" target="_blank">
              Visualizar
            </a>

            <button
              v-if="qrcode.photo"
              class="hover:underline w-1/8"
              type="button"
              @click="remove()"
            >
              <icon name="trash" class="flex-shrink-0 mb-3 w-4 h-4 fill-red-600" />
            </button>
          </div>

          <select-input v-model="form.active" :error="form.errors.active" class="pr-6 pb-8 w-full " label="Ativo">
            <option :value="null" />
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!qrcode.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Deletar QRCode
          </button>
          <button v-if="qrcode.url" class="btn-generate-pdf ml-auto" type="button" @click="generateReport">
            Gerar
            PDF
          </button>&nbsp;
          <button v-if="qrcode.url" class="btn-generate-qrcode ml-auto" type="button" @click="showModal">
            Ver
            QRCode
          </button>&nbsp;
          <Modal
            v-show="isModalVisible"
            :url="qrcode.interaction"
            :name="qrcode.name"
            @close="closeModal"
          />
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            Atualizar
            QRCode
          </loading-button>
        </div>
      </form>
    </div>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :filename="qrcode.name"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
    >
      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <br /><br /><br />
        <br /><br /><br />
        <img v-if="qrcode.photo_path" class="center" :src="qrcode.photo_path" crossorigin="anonymous" alt="Photo" />
        <br /><br /><br />
        <br /><br /><br />
        <qrcode class="center" :size="400" cls="qrcode" :value="qrcode.interaction" />
        <br /><br /><br />
        <br /><br /><br />
        <h1 style="text-align:center;font-size: 50px">{{ qrcode.city }}</h1>
        <h1 style="text-align:center;font-size: 50px">&nbsp;</h1>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datepicker'
import TextareaInput from '@/Shared/TextareaInput'
import moment from 'moment'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import Modal from '@/Shared/Modal'
import VueHtml2pdf from 'vue-html2pdf'
import Qrcode from 'v-qrcode/src/index'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'

export default {
  metaInfo() {
    return {title: this.form.name}
  },
  components: {
    Datepicker,
    Modal,
    LoadingButton,
    TextInput,
    TrashedMessage,
    SelectInput,
    TextareaInput,
    VueHtml2pdf,
    Qrcode,
    Icon,
    FileInput,
  },
  layout: Layout,
  props: {
    qrcode: Object,
    organizations: Array,
    showOrganizations: Boolean,
  },
  remember: 'form',
  data() {
    return {
      output: null,
      ptBR: ptBR,
      isModalVisible: false,
      form: this.$inertia.form({
        _method: 'put',
        organization_id: this.qrcode.organization_id,
        name: this.qrcode.name,
        description: this.qrcode.description,
        code: this.qrcode.code,
        url: this.qrcode.url,
        interaction: this.qrcode.interaction,
        start_date: this.qrcode.start_date,
        end_date: this.qrcode.end_date,
        lat: this.qrcode.latitude ? String(this.qrcode.latitude) : null,
        lng: this.qrcode.longitude ? String(this.qrcode.longitude) : null,
        photo: null,
        photo_path: this.qrcode.photo_path,
        phone: this.qrcode.phone,
        state_id: this.qrcode.state_id,
        city_id: this.qrcode.city_id,
        state: null,
        active: this.qrcode.active,
      }),
    }
  },
  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('L')
    },
    update() {
      this.form.post(this.route('qrcodes.update', this.qrcode.id).url())
    },
    destroy() {
      if (confirm('Tem certeza de que deseja excluir este qrcode?')) {
        this.$inertia.delete(this.route('qrcodes.destroy', this.qrcode.id))
      }
    },
    remove() {
      if (confirm('Tem certeza de que deseja remover a Imagem?')) {
        this.$inertia.put(this.route('qrcodes.remove', [this.qrcode.id, 'photo']))
      }
    },
    restore() {
      if (confirm('Tem certeza de que deseja restaurar este qrcode?')) {
        this.$inertia.put(this.route('qrcodes.restore', this.qrcode.id))
      }
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
  },
}
</script>
<style>
.center {
    margin: auto;
    width: 50%;
    padding: 10px;
}
</style>
